import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'
import axios from '@/libs/axios'

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async createAttendanceLog({ commit }, params) {
      try {
        const response = await axios.post('uni/attendanceLogs', params)
        const { data } = response
        return {
          isSuccessful: data.code === ApiCode.SUCCESS,
          message: data.message,
        }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
  },
}
